import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  marketingRouter: Array<RouteRecordRaw> = [
    {
        path: '/marketing',
        name: '营销管理',
        component: Layout,
        meta: { title: '营销管理', icon: 'icon-discount', alwaysShow: true },
        children: [
            {
                path: 'special_goods_list',
                name: '特殊商品管理',
                component: () => import('@/views/marketing/SpecialGoodsList.vue'),
                meta: { title: '特殊商品管理' }
            },
            {
                path: 'daily_delivery_product',
                name: '当日达商品管理',
                component: () => import('@/views/marketing/DailyDeliveryProduct.vue'),
                meta: { title: '当日达商品管理' }
            },
            {
                path: 'similar-recommend',
                name: '相似商品推荐',
                component: () => import('@/views/marketing/SimilarRecommend.vue'),
                meta: { title: '相似商品推荐' }
            },
            {
                path: 'similar-recommend-edit',
                name: '相似商品推荐编辑',
                component: () => import('@/views/marketing/SimilarRecommendEdit.vue'),
                meta: { title: '相似商品推荐编辑' }
            },
            {
                path: 'recommend',
                name: '商品推荐',
                component: () => import('@/views/marketing/Recommend.vue'),
                meta: { title: '商品推荐', keepAlive: true }
            },
            {
                path: 'recommend-product-edit',
                name: '推荐商品编辑',
                component: () => import('@/views/marketing/RecommendProductEdit.vue'),
                meta: { title: '推荐商品编辑' }
            },
            {
                path: 'recommended-brand-edit',
                name: '被推荐品牌编辑',
                component: () => import('@/views/marketing/RecommendedBrandEdit.vue'),
                meta: { title: '被推荐品牌编辑' }
            },
            {
                path: 'recommended-product',
                name: '被推荐商品列表',
                component: () => import('@/views/marketing/RecommendedProduct.vue'),
                meta: { title: '添加推荐商品列表', keepAlive: true }
            },
            {
                path: 'recommended-product-edit',
                name: '被推荐商品编辑',
                component: () => import('@/views/marketing/RecommendedProductEdit.vue'),
                meta: { title: '被推荐商品编辑' }
            },
            {
                path: 'festival-tip',
                name: '节日提示语',
                component: () => import('@/views/marketing/FestivalTip.vue'),
                meta: { title: '节日提示语' }
            },
            {
                path: 'key-customer',
                name: '重点客户',
                component: () => import('@/views/marketing/KeyCustomer.vue'),
                meta: { title: '重点客户' }
            },
            {
                path: 'cooperation',
                name: '商务合作申请列表',
                component: () => import('@/views/marketing/CooperationApply.vue'),
                meta: { title: '商务合作申请' }
            },
            {
                path: 'GiftExhibition',
                name: '礼品展申请列表',
                component: () => import('@/views/marketing/GiftExhibition.vue'),
                meta: { title: '礼品展合作' }
            },
            {
                path: 'member-coupon',
                name: '会员优惠券',
                component: () => import('@/views/marketing/MemberCoupon.vue'),
                meta: { title: '会员优惠券' }
            },
            {
                path: 'member-day',
                name: '会员日',
                component: () => import('@/views/marketing/MemberDay.vue'),
                meta: { title: '会员日' }
            },
            {
                path: 'member-privilege',
                name: '会员特权',
                component: () => import('@/views/marketing/MemberPrivilege.vue'),
                meta: { title: '会员特权' }
            },
            {
                path: 'member-resource',
                name: '会员资源位',
                component: () => import('@/views/marketing/MemberResource.vue'),
                meta: { title: '会员资源位' }
            },
            {
                path: 'opinion-list',
                name: '意见反馈',
                component: () => import('@/views/marketing/OpinionList.vue'),
                meta: { title: '意见反馈' }
            },
            {
                path: 'free-coupon',
                name: '下单送券配置',
                component: () => import('@/views/marketing/OrderFreeCoupon.vue'),
                meta: { title: '下单送券配置' }
            },
            {
                path: 'activity-list',
                name: '运营活动列表',
                component: () => import('@/views/marketing/ActivityList.vue'),
                meta: { title: '活动列表' }
            },
            {
                path: 'operate_product-list',
                name: '运营商品管理',
                component: () => import('@/views/merchant-admin/ProductList.vue'),
                meta: { 
                    title: '运营商品管理',
                    keepAlive: true, 
                    v:1,//运营端
                    depth: 30 }
            },
            {
                path: 'index-icon',
                name: '首页弹窗配置',
                component: () => import('@/views/marketing/IndexPopUpList.vue'),
                meta: { title: '商城弹窗配置' }
            },
            {
                path: 'ad',
                name: '广告配置',
                component: () => import('@/views/marketing/AdList.vue'),
                meta: { title: '列表穿插广告' }
            },
            {
                path: 'label-list',
                name: '商品标签管理',
                component: () => import('@/views/marketing/LabelList.vue'),
                meta: { title: '商品标签管理' }
            },
            {
                path: 'group-label-list',
                name: '商品标签组管理',
                component: () => import('@/views/marketing/GroupLabelList .vue'),
                meta: { title: '商品标签组管理' }
            },
            {
                path: 'up-down-log-list',
                name: '上下架日志',
                component: () => import('@/views/marketing/UpDownLogList.vue'),
                meta: { title: '上下架日志' }
            },
            {
                path: 'generate-coupon-pic',
                name: '电子券图生成',
                component: () => import('@/views/marketing/coupon/GenerateCouponPic.vue'),
                meta: { title: '电子券图生成' }
            },
            {
                path: 'search-config',
                name: '热搜配置',
                component: () => import('@/views/marketing/SearchConfig.vue'),
                meta: { title: '热搜配置' }

            },
            {
                path: 'delivery-rule',
                name: '配送规则',
                component: () => import('@/views/marketing/DeliveryRule.vue'),
                meta: { title: '配送规则' }

            },
            {
                path: 'coupon-package-list',
                name: '优惠券包列表',
                component: () => import('@/views/marketing/coupon/CouponPackageList.vue'),
                meta: { title: '优惠券列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'coupon-package-edit',
                name: '优惠券包编辑',
                component: () => import('@/views/marketing/coupon/CouponPackageEdit.vue'),
                meta: { title: '优惠券包编辑' }
            },
            {
                path: 'coupon-list',
                name: '线上券列表',
                component: () => import('@/views/marketing/coupon/CouponList.vue'),
                meta: { title: '线上券列表' }
            },
            {
                path: 'pay-product-list',
                name: '支付页商品推荐',
                component: () => import('@/views/marketing/PayProductList.vue'),
                meta: { title: '支付页商品推荐' }
            },
        ]
    }
]

export default  marketingRouter